import React, { useState, useEffect } from "react";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import { t } from "i18next";
import DataManager from "../../../General/DataManager";
import UserClass from "../../../General/LocalStorage/UserClass";
import Functions from "../../../General/Functions";


const Settings = () => {

    const [message, setMessage] = useState(null);
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        const instance = UserClass.getInstance();
        const userToken = instance.getTokenUser();
        const getSettings = async (userToken) => {
            try {
                const response = await DataManager.getSettings(userToken);
                setSettings(response["result"]);
            } catch (error) {
                console.error('Failed to fetch settings:', error);

            }
        };
        getSettings(userToken);

    }, [])


    const handleInputChange = (e, key) => {
        const newValue = e.target.value;
        setSettings(prevSettings => {
            return prevSettings.map(item => {
                if (item.key === key) {
                    return {
                        ...item,
                        value: newValue
                    };
                } else {
                    return item;
                }
            });
        });
    };

    const handleUpdate = async () => {
        const hasEmpty = settings.some(
            (item) => !item.value || !item.value.toString().trim()
        );

        if (hasEmpty) {
            Functions.alertMsg(t("settings_empty_field"));
            return;
        }

        try {
            const instance = UserClass.getInstance();
            const userToken = instance.getTokenUser();
            const response = await DataManager.updateSettings(userToken, settings);
            if (response && response.data) {
                setSettings(response.data);
                Functions.alertMsgSuccess(t("settings_update_success"));
            } else {

                Functions.alertMsg(t("settings_update_failed"));

            }
        } catch (err) {
            Functions.alertMsg(t("error_occured_in_update"));
        }
    };


    return (
        <Container
            className="d-flex justify-content-center align-items-start py-5"
            style={{ minHeight: "100vh", backgroundColor: "#f2f4f8" }}
        >
            <Card className="w-100 mx-3" style={{ maxWidth: "90%", padding: "10px" }}>
                <Card.Body>
                    <Card.Title
                        className="text-center mb-6"
                        style={{ fontSize: "1.75rem", fontWeight: 600 }}
                    >
                        {t('config_settings')}
                    </Card.Title>

                    {settings ? (
                        <>
                            {settings.filter(setting => setting.visible).length > 0 ? (
                                <>
                                    <Form.Group controlId="settingInput" className="mb-3">
                                        {settings.map((setting) =>
                                            setting?.visible ? (
                                                <div key={setting.key}>
                                                    <Form.Label>{setting?.labelView}:</Form.Label>
                                                    <Form.Control
                                                        type={setting?.htmlFormat}
                                                        placeholder="Enter new value"
                                                        value={setting?.value}
                                                        onChange={(e) =>
                                                            handleInputChange(e, setting?.key)
                                                        }
                                                    />
                                                </div>
                                            ) : null
                                        )}
                                    </Form.Group>
                                    <Button
                                        variant="primary"
                                        className="w-100 py-2"
                                        onClick={handleUpdate}
                                    >
                                        {t('update')}
                                    </Button>
                                </>
                            ) : (
                                <p className="text-center text-muted">
                                    {t('no_available_settings')}
                                </p>
                            )}
                        </>
                    ) : (
                        <p className="text-center text-muted">
                            {t('no_available_settings')}
                        </p>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );

};

export default Settings;
